import React, { useMemo } from 'react';

const EMOJIS = ['🐱', '🐱', '🐱', '💕', '💖', '💗', '🌸', '🌺', '💐', '🌷', '😻', '🐾'];

function FloatingItem({ emoji, style }) {
  return (
    <span
      style={{
        position: 'fixed',
        fontSize: style.size,
        left: style.left,
        animationName: 'chloe-float',
        animationDuration: style.duration,
        animationDelay: style.delay,
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        opacity: 0,
        zIndex: 9999,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      {emoji}
    </span>
  );
}

export default function ChloeModeOverlay() {
  const items = useMemo(() => {
    return Array.from({ length: 30 }, (_, i) => ({
      id: i,
      emoji: EMOJIS[i % EMOJIS.length],
      style: {
        size: `${Math.random() * 20 + 16}px`,
        left: `${Math.random() * 100}vw`,
        duration: `${Math.random() * 6 + 5}s`,
        delay: `${Math.random() * 8}s`,
      },
    }));
  }, []);

  return (
    <>
      <style>{`
        @keyframes chloe-float {
          0% {
            transform: translateY(110vh) rotate(0deg);
            opacity: 0;
          }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% {
            transform: translateY(-10vh) rotate(${Math.random() > 0.5 ? '' : '-'}${Math.floor(Math.random() * 360)}deg);
            opacity: 0;
          }
        }
      `}</style>
      {items.map(item => (
        <FloatingItem key={item.id} emoji={item.emoji} style={item.style} />
      ))}
    </>
  );
}
